// Minimal hash router — no framework, per spec ("plain modern JavaScript").
// Routes: #/login #/ #/course/:id #/course/:id/topic/:topicId #/settings

import { brandMarkHtml } from './components/brandMark.js';

const routes = [];
let currentCleanup = null;

// Page-transition "wait sign" — the same animated Simustage brand mark used
// in the topbar/sign-in screen (see components/brandMark.js), shown
// full-screen for every route change. Lives outside #app so a view's own
// `container.innerHTML = ''` can never wipe it out from under itself.
// MIN_VISIBLE_MS keeps it up for a minimum stretch even when the new route
// renders synchronously, so navigating always reads as one deliberate
// branded transition rather than an inconsistent flash.
let overlayEl = null;
function getOverlay() {
  if (overlayEl) return overlayEl;
  overlayEl = document.createElement('div');
  overlayEl.className = 'page-transition-overlay';
  overlayEl.innerHTML = brandMarkHtml();
  document.body.appendChild(overlayEl);
  return overlayEl;
}

const MIN_VISIBLE_MS = 260;

export function route(pattern, handler) {
  const paramNames = [];
  const regex = new RegExp('^' + pattern.replace(/:[^/]+/g, (m) => {
    paramNames.push(m.slice(1));
    return '([^/]+)';
  }) + '$');
  routes.push({ regex, paramNames, handler });
}

async function resolve() {
  const hash = location.hash.slice(1) || '/';
  const path = hash.split('?')[0];
  for (const r of routes) {
    const match = path.match(r.regex);
    if (match) {
      const params = {};
      r.paramNames.forEach((name, i) => { params[name] = decodeURIComponent(match[i + 1]); });
      const overlay = getOverlay();
      overlay.classList.add('visible');
      const shownAt = Date.now();
      if (typeof currentCleanup === 'function') { try { currentCleanup(); } catch (e) {} }
      currentCleanup = await r.handler(params);
      const remaining = MIN_VISIBLE_MS - (Date.now() - shownAt);
      if (remaining > 0) await new Promise((res) => setTimeout(res, remaining));
      overlay.classList.remove('visible');
      return;
    }
  }
  location.hash = '#/';
}

export function startRouter() {
  window.addEventListener('hashchange', resolve);
  resolve();
}

export function navigate(path) {
  location.hash = `#${path}`;
}
